import { Section } from './types';

export const sectionToPath: Record<Section, string> = {
  [Section.Home]: '/',
  [Section.Work]: '/work',
  [Section.Skills]: '/skills',
  [Section.About]: '/about',
  [Section.Contact]: '/contact'
};

export const pathToSection = (pathname: string): Section => {
  if (pathname === '/' || pathname === '') return Section.Home;
  if (pathname.startsWith('/work')) return Section.Work;
  if (pathname.startsWith('/skills')) return Section.Skills;
  if (pathname.startsWith('/about')) return Section.About;
  if (pathname.startsWith('/contact')) return Section.Contact;
  return Section.Home;
};
